module.exports = __webpack_public_path__ + "static/media/result-url.188526bc.svg";